import getUpdateForProperty from './getUpdateForProperty';
import Task from '../schema/Task';
import Subtask from '../schema/Subtask';
import { Todo, Subtodo } from 'owa-todo-types';

/**
 * Converts partial Todo/Subtodo types into service friendly Task/Subtask objects
 * @param updates property updates to convert
 * @param ignoreNullValues true to ignore all properties that have a null value
 */
export function toServiceObject(updates: Partial<Todo>, ignoreNullValues?: boolean): Partial<Task>;
export function toServiceObject(
    updates: Partial<Subtodo>,
    ignoreNullValues?: boolean
): Partial<Subtask>;
export default function toServiceObject(updates, ignoreNullValues?) {
    if (!updates) {
        return null;
    }

    const filteredUpdates = Object.keys(updates)
        .map((key: keyof Todo | keyof Subtodo) =>
            tryGetUpdateForProperty(key, updates[key], ignoreNullValues)
        )
        .filter(update => !!update);

    if (filteredUpdates.length === 0) {
        return null;
    }

    const restAPIUpdates = {};
    filteredUpdates.forEach(item => {
        restAPIUpdates[item.key] = item.value;
    });

    return restAPIUpdates;
}

function tryGetUpdateForProperty(
    todoPropertyName: keyof Todo | keyof Subtodo,
    value: any,
    ignoreNullValues?: boolean
) {
    if (ignoreNullValues && value === null) {
        return null;
    }

    return getUpdateForProperty(todoPropertyName, value);
}
